var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import clsx from 'clsx';
import { rem } from '../utils/Polished';
import { withForwardedRef } from '../utils/helpers/reactHelpers';
const PopupActionsSC = styled.div `
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: flex-end;
  margin-top: ${rem('12px')};

  > * {
    margin: 0 ${rem('12px')} 0 0;

    &:last-child {
      margin-right: 0;
    }
  }
`;
const PopupActions = (props) => {
    const { children, forwardedRef, className: classNameProp } = props, others = __rest(props, ["children", "forwardedRef", "className"]);
    return children ? (React.createElement(PopupActionsSC, Object.assign({ ref: forwardedRef, className: clsx(classNameProp) }, others), children)) : null;
};
PopupActions.propTypes = {
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    forwardedRef: PropTypes.any,
    className: PropTypes.string
};
PopupActions.defaultProps = {
    children: null,
    forwardedRef: React.createRef(),
    className: undefined
};
export default withForwardedRef(PopupActions);
//# sourceMappingURL=PopupActions.js.map